import React from 'react';
import { CTAButton } from './CTAButton';
export function ProblemSection() {
  const problems = ['Llegas a cada semana sin una estructura clara… armando todo sobre la marcha', 'Perdés horas haciendo planificaciones, sesiones o registros desde cero', 'Sientes que siempre te falta algo: formatos, evaluaciones, documentos o actividades', 'Aunque trabajas mucho, igual terminas con estrés y desorden'];
  return <section className="bg-brand-dark text-white py-5 px-5" data-id="element-236">
      <div className="max-w-xl mx-auto" data-id="element-237">
        <h2 className="text-2xl md:text-3xl font-bold text-center mb-3 leading-tight" data-id="element-238">
          😩 ¿Estás viviendo esto...?
        </h2>
        <p className="text-center text-brand-yellow font-bold text-lg mb-8" data-id="element-239">
          Te va a sonar familiar:
        </p>

        <div className="space-y-3 mb-10" data-id="element-240">
          {problems.map((problem, idx) => <div key={idx} className="bg-gray-900 border border-gray-800 p-4 rounded-xl flex items-start gap-3" data-id="element-241">
              <span className="text-red-500 text-lg flex-shrink-0" data-id="element-242">❌</span>
              <p className="text-sm text-gray-300 font-medium leading-relaxed" data-id="element-243">
                {problem}
              </p>
            </div>)}
        </div>

        <div className="text-center" data-id="element-244">
          <h3 className="text-xl md:text-2xl font-bold text-brand-yellow mb-6" data-id="element-245">
            ¿Cuánto tiempo más vas a seguir trabajando así?
          </h3>
        </div>

        <div className="bg-brand-yellow/10 border border-brand-yellow/20 rounded-2xl p-6" data-id="element-246">
          <h3 className="text-lg font-bold text-white mb-4 flex items-center gap-2" data-id="element-247">
            <span data-id="element-248">💡</span> Esto es lo que cambia cuando usás el MegaPack:
          </h3>
          <div className="space-y-3" data-id="element-249">
            {['Sabés exactamente qué hacer cada semana sin dudar', 'Dejás de perder tiempo armando todo desde cero', 'Sentís control total sobre tu planificación y tus clases', 'Volvés a disfrutar enseñar sin el caos y la sobrecarga'].map((text, i) => <div key={i} className="flex items-start gap-3" data-id="element-250">
                <span className="text-green-500 flex-shrink-0" data-id="element-251">✅</span>
                <p className="text-sm text-gray-200 font-medium leading-relaxed" data-id="element-252">
                  {text}
                </p>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}